(ns frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [common.util :as cu]))

(defn largest-investments-at-fair-value-card
  [{:keys [rich-content rich-content-path figures] :as data}
   {:keys [edit-mode? save-text] :as props}]
  [card
   {:title "Largest investments at fair value"}
   [:<>
    [chart figures]
    (text-content/optional-footnote data props)]])

(defn largest-investments-by-NAV
  [{:keys [rich-content rich-content-path figures] :as data}
   {:keys [edit-mode? save-text] :as props}]
  [card
   {:title "Largest investments - Property by NAV"}
   [:<>
    [chart figures]
    (text-content/optional-footnote data props)]])
